import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators';
import store, { sbsModule } from '@/store';

interface IApplicationState {
    isAuthorized: boolean;
}

@Module({ namespaced: true, name: 'application', dynamic: true, store })
class ApplicationState extends VuexModule implements IApplicationState {
    isAuthorized: boolean = false;

    @Action({ rawError: true })
    public async bootstrap() : Promise<void> {
        if(sbsModule.token) {
            this.setAuthorized(true);
        }
        else {
            this.setAuthorized(false);
        }
    }

    @Mutation
    public setAuthorized(isAuthorized: boolean) : void {
        this.isAuthorized = isAuthorized;
    }
}

const applicationModule = getModule(ApplicationState);
export default applicationModule;